import React, { ChangeEvent, useState } from "react";
import "./App.css";
import { DatePicker, TaskPicker, RangePicker } from "date-picker-httrkk";

function App() {
  const [highlightWeekends, setHighlightWeekends] = useState(false);
  const [hideHolidays, setHideHolidays] = useState(false);
  const [weekStarts, setWeekStarts] = useState("Sunday");

  const weekendsHandler = (e: ChangeEvent<HTMLInputElement>) =>
    setHighlightWeekends(e.target.checked);

  const holidaysHandler = (e: ChangeEvent<HTMLInputElement>) =>
    setHideHolidays(e.target.checked);

  const weekStartsHandler = (e: ChangeEvent<HTMLInputElement>) => {
    // console.log(e.target.value);
    setWeekStarts(e.target.value);
  };
  return (
    <div className="App">
      <div className="wrapper">
        <div className="controls">
          <label htmlFor="">
            <input
              type="checkbox"
              value="highlight weekends"
              checked={highlightWeekends}
              onChange={weekendsHandler}
            />
            highlight weekends
          </label>

          <label htmlFor="">
            <input
              type="checkbox"
              value="show holidays"
              checked={hideHolidays}
              onChange={holidaysHandler}
            />
            show holidays
          </label>

          <label htmlFor="">
            <input
              type="radio"
              value="Sunday"
              checked={weekStarts === "Sunday"}
              onChange={weekStartsHandler}
            />
            Sunday
          </label>

          <label htmlFor="">
            <input
              type="radio"
              value="Monday"
              checked={weekStarts === "Monday"}
              onChange={weekStartsHandler}
            />
            Moday
          </label>
        </div>

        <div className="block">
          <h1>TasPicker</h1>
          <TaskPicker
            hideHolidays={setHideHolidays}
            isHighlightWeekends={highlightWeekends}
            weekStarts={weekStarts}
          />
        </div>

        <div className="block">
          <h1>DatePicker</h1>
          <DatePicker
            hideHolidays={setHideHolidays}
            isHighlightWeekends={highlightWeekends}
            weekStarts={weekStarts}
          />
        </div>

        <div className="block">
          <h1>RangePicker</h1>
          <RangePicker
            hideHolidays={setHideHolidays}
            isHighlightWeekends={highlightWeekends}
            weekStarts={weekStarts}
          />
        </div>
      </div>
    </div>
  );
}

export default App;
